var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettlement(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6576 4.66392V2.66525C12.6576 2.48855 12.5875 2.3191 12.4625 2.19416C12.3376 2.06921 12.1681 1.99902 11.9914 1.99902H3.3305C2.97711 1.99902 2.6382 2.13941 2.38831 2.38929C2.13843 2.63917 1.99805 2.97809 1.99805 3.33147C1.99805 3.68486 2.13843 4.02378 2.38831 4.27366C2.6382 4.52354 2.97711 4.66392 3.3305 4.66392H13.3239C13.5006 4.66392 13.67 4.73411 13.795 4.85906C13.9199 4.984 13.9901 5.15345 13.9901 5.33015V7.99505M13.9901 7.99505H11.9914C11.638 7.99505 11.2991 8.13543 11.0492 8.38531C10.7994 8.6352 10.659 8.97411 10.659 9.3275C10.659 9.68089 10.7994 10.0198 11.0492 10.2697C11.2991 10.5196 11.638 10.6599 11.9914 10.6599H13.9901C14.1668 10.6599 14.3362 10.5898 14.4612 10.4648C14.5861 10.3399 14.6563 10.1704 14.6563 9.99372V8.66127C14.6563 8.48458 14.5861 8.31512 14.4612 8.19018C14.3362 8.06524 14.1668 7.99505 13.9901 7.99505Z",
    stroke: "#4A5565",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99805 3.33105V12.6582C1.99805 13.0116 2.13843 13.3505 2.38831 13.6004C2.6382 13.8503 2.97711 13.9907 3.3305 13.9907H13.3239C13.5006 13.9907 13.67 13.9205 13.795 13.7955C13.9199 13.6706 13.9901 13.5011 13.9901 13.3244V10.6595",
    stroke: "#4A5565",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettlement);
export default __webpack_public_path__ + "static/media/settlement.a430b3c8d601ff232d037a137cc41df1.svg";
export { ForwardRef as ReactComponent };